import * as _ from "lodash";
import {Node} from "../Node";
import {AbstractProperty} from "./AbstractProperty";
import {PNodeList} from "./PNodeList";
import {assertInstanceOf} from "../../global";
import {PNodeListAbstract} from "./PNodeListAbstract";

export class PNodeRef<N extends Node> extends AbstractProperty<string, N> {

    default: string;
    nodeList: (PNodeRef) => PNodeList<N>;

    constructor(args) {
        super({
            type: 'NodeRef',
            default: null,
            ...args
        });
    }

    typeCheck(value) {
        return _.isString(value);
    }

    set(value: string) {
        let valueIntern = value ?? this.createDefault();
        if (valueIntern != null) {
            const selectOptions = this.getSelectOptions();
            if (!selectOptions.some(pk => pk == value)) {
                console.warn('PNodeRef ', value, ' not found in selectOptions', selectOptions);
                valueIntern = null;
            }
        }
        this._performTypeCheck(valueIntern);
        this.node[this.name] = valueIntern;
        return valueIntern;
    }

    getSelectOptions(): string[] {
        const list = this.getNodeList().get() ?? [];
        return list.map(node => node.getKey());
    }

    getNodeList(): PNodeList<N> {
        const nodeList = this.nodeList(this);
        assertInstanceOf(this.node?.getName() + '.' + this.name + '.nodeList', nodeList, PNodeListAbstract);
        return nodeList;
    }

    getNode(): N {
        return this.getNodeList().findKey(this.get());
    }

}
